export default "__VITE_ASSET___$HjgVmd__"